// A cell that starts with =, +, -, @, tab or return would run as a formula
// when the CSV opens in Excel or Sheets; a leading quote keeps it as text.
export const csvCell = (value) => {
  const text = String(value ?? "");
  const safe = /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
};

export const csvLine = (cells) => cells.map((cell) => (typeof cell === "number" ? String(cell) : csvCell(cell))).join(",");
